//Componentes generales
import React, { useReducer } from "react";
import agregarReqReducer from "./agregarReqReducer";
import agregarReqContext from "./agregarReqContext";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import {
  addTransactionDocument,
  getTDocByCodNroFor,
  updateAditionalDocs,
  updateTDoc,
} from "../../api/transactionDocuments";
import { getAbmProduct, getAbmProductByTDoc } from "../../api/abmProduct";
//Acciones
import {
  CARGAR_ITEM,
  MODIFICAR_REQ,
  CARGAR_REQ,
  SELECCIONAR_PRODUCTO,
  ELIMINAR_ITEM,
  MODIFICAR_ITEM,
  SELECCIONAR_ITEM,
  CARGAR_PRODUCTOS,
  GUARDAR_COMPROBANTE,
  CARGANDO_ADD,
  ERROR_ADD,
  SELECCIONAR_FILE,
  ELIMINAR_FILE,
  ERROR,
  LIMPIAR_ERROR,
} from "./agregarReqActions";

/* 
    State encargado de la llamada al backend para agregar un nuevo comprobante.
*/
const AgregarReqState = (props) => {
  //Valores inciales
  const initialState = {
    req: {
      codOri: "",
      observ: "",
      importe: "",
      moneda: "",
      cotizacion: null,
      tDocCodFor: "",
      tDocCodForDescrp: "",
      nroCta: "",
      nroCtaDescrp: "",
      cuitProv: "",
      quantity: 0,
      dateOfIssue: null,
      observada: false,
      motivoObserv: "",
    },
    files: [],
    itemsList: [],
    products: [],
    productSelected: null,
    itemSelected: null,
    modReq: false,
    cargando: false,
    error: "",
  };

  const [state, dispatch] = useReducer(agregarReqReducer, initialState);

  /* 
        Función encargada de guardar un comprobante.
            Donde requeriment es el comprobante a guardar.
                  items son los items/productos del comprobante a guardar.
                  user es el usario en sesión.
                  files son los archivos adjuntado a un comprobante.
    */
  const guardarComprobante = async (requeriment, products, user, files, conceptos = [], aditionalDocs) => {
    let createdTDoc = null;

    try {
      const tDoc = {
        ...requeriment,
        quantity: products.length,
        tDocUserID: user._id,
        userName: user.userName,
      };

      const formData = new FormData();

      if (files?.length > 0) {
        files.map((f, i) => {
          formData.append(`${i}`, f);
        });
      } else {
        throw new Error("El comprobante requiere un archivo adjunto");
      }

      formData.append("transactionDocument", JSON.stringify(tDoc));
      formData.append("products", JSON.stringify(products));
      formData.append("conceptos", JSON.stringify(conceptos));

      const resp = await addTransactionDocument(formData);
      createdTDoc = resp.data.data;

      console.log("aditionalDocs en guardarComprobante de agregarReqState");
      console.log(aditionalDocs);
      
      // let respAdiDocs = await updateAditionalDocs();

      dispatch({
        type: GUARDAR_COMPROBANTE,
      });
      console.log("Guardar comprobante");
      console.log(createdTDoc);
      return createdTDoc;
    } catch (error) {
      /* dispatch({
        type: ERROR,
        payload: error.message ||
      "No se puede guardar el comprobante",
      }); */
      throw error;
    }
  };

  /* 
        Función que actualiza la lista de productos.
    */
  const actualizarProducts = async () => {
    try {
      const resp = await getAbmProduct();

      dispatch({
        type: CARGAR_PRODUCTOS,
        payload: resp.data.data,
      });
    } catch (error) {
      console.log(error);
    }
  };

  /*
        Función encargada de cargar el comprobante.
            Donde req es el comprobante a cargar.
        Actualmente no esta en uso.
    */
  const cargarComprobante = (req) => {
    dispatch({
      type: CARGAR_REQ,
      payload: req,
    });
  };

  /* 
        Función que selecciona un producto.
            Donde product es el producto.
    */
  const seleccionarProducto = (product) => {
    dispatch({
      type: SELECCIONAR_PRODUCTO,
      payload: product,
    });
  };

  /* 
        Función que carga un item.
            Donde item es el item a cargar.
    */
  const cargarItem = (item) => {
    dispatch({
      type: CARGAR_ITEM,
      payload: item,
    });
  };

  /* 
        Función elimina un item.
            Donde index es la posición del item a eliminar.
    */
  const eliminarItem = (index) => {
    dispatch({
      type: ELIMINAR_ITEM,
      payload: index,
    });
  };

  /* 
        Función que modifica un item.
            Donde index es la posición del item a modificar.
                  nuevoItem es el item modificado.
    */
  const modificarItem = (index, nuevoItem) => {
    dispatch({
      type: MODIFICAR_ITEM,
      payload: {
        index,
        item: nuevoItem,
      },
    });
  };

  /* 
        Función que selecciona el item.
            Donde item es el item a seleccionar.
    */
  const seleccionarItem = (item) => {
    dispatch({
      type: SELECCIONAR_ITEM,
      payload: item,
    });
  };

  /* 
        Función que modifica un comprobante.
            Donde modificar es el comprobante modificado.
    */
  const modificarComprobante = (modificar) => {
    dispatch({
      type: MODIFICAR_REQ,
      payload: modificar,
    });
  };

  /* 
        Función que edita un comprobante.
            Donde tDoc es el comprobante modificado.
                  productList son los items del comprobante modificado.
                  files son los archivos adjuntados al comprobante modificado.
                  usuario es el usuario en sesión.
    */
  const editarComprobanteBE = async (
    tDoc,
    productList,
    files,
    usuario,
    conceptos = [],
    aditionalDocs
  ) => {
    try {

      console.log("aditionalDocs en agregarReqState");
      console.log(aditionalDocs);
      
      const formData = new FormData();
      
      formData.append("tDocId", JSON.stringify(tDoc._id));
      formData.append("updates", JSON.stringify({ ...tDoc, quantity: productList.length }));
      formData.append("fecMod", JSON.stringify(tDoc.fecMod));
      formData.append("user", JSON.stringify(usuario));
      formData.append("products", JSON.stringify(productList));
      formData.append("conceptos", JSON.stringify(conceptos));

      if (!files?.length) {
        throw new Error("Debe existir al menos un archivo");
      }

      // Archivos nuevos
      if (files?.length > 0) {
        files.forEach((file) => {
          formData.append("files", file);
        });
      }

      const resp = await updateTDoc(formData);

      // Solo proceso adicionales con cambios: nuevos (ADD) o eliminados (DELETE).
      // Los ya guardados sin cambios (SAVED) no se reenvían.
      const aditionalDocsConCambios = aditionalDocs?.filter(
        ({ action }) => action === "ADD" || action === "DELETE"
      );

      if(aditionalDocsConCambios?.length > 0){
        const formData2 = new FormData();

        formData2.append("tDocCodFor", tDoc.tDocCodFor);
        formData2.append("tDocNroFor", tDoc.tDocNroFor);

        aditionalDocsConCambios.forEach(({file, action, name, key}, i) => {
          formData2.append(`action_${i}`, action);
          if (action === "ADD") {
            formData2.append(`file_${i}`, file);
          } else if (action === "DELETE") {
            // key/name = key completa en S3 (con prefijo y _ADIC_)
            formData2.append(`name_${i}`, key || name);
          }
        })

        await updateAditionalDocs(formData2)
      }

      const tDocUpdated = resp.data.data;

      dispatch({
        type: GUARDAR_COMPROBANTE,
      });

      return tDocUpdated;
    } catch (error) {
/*       dispatch({
        type: ERROR_ADD,
        payload: error.message,
      }); */
      throw error;
    }
  };

  /* 
        Función para carga.
        No esta en uso.
    */
  const cargando = async () => {
    dispatch({
      type: CARGANDO_ADD,
    });
  };

  /* 
        Función que selecciona un archivo.
    */
  const seleccionarFile = async () => {
    try {
      const fileUpload = null;

      if (fileUpload.name !== undefined) {
        dispatch({
          type: SELECCIONAR_FILE,
          payload: fileUpload,
        });
      }
    } catch (error) {}
  };

  /* 
        Función que eliminar un archivo.
            Donde fle es el archivo a eliminar.
    */
  const eliminarFile = (file) => {
    console.log(file);
    dispatch({
      type: ELIMINAR_FILE,
      payload: file,
    });
  };

  /* 
        Función que limpia el valor de error.
    */
  const limpiarError = async () => {
    dispatch({
      type: LIMPIAR_ERROR,
    });
  };

  return (
    <agregarReqContext.Provider
      value={{
        req: state.req,
        modReq: state.modReq,
        itemsList: state.itemsList,
        products: state.products,
        productSelected: state.productSelected,
        itemSelected: state.itemSelected,
        isCargando: state.cargando,
        error: state.error,
        cargarComprobante,
        modificarComprobante,
        seleccionarProducto,
        cargarItem,
        eliminarItem,
        modificarItem,
        seleccionarItem,
        actualizarProducts,
        guardarComprobante,
        cargando,
        seleccionarFile,
        eliminarFile,
        limpiarError,
        editarComprobanteBE,
      }}
    >
      {props.children}
    </agregarReqContext.Provider>
  );
};

export default AgregarReqState;

/* 
    Actualmente no esta en uso.
*/
const toFileUpload = (file) => {
  let { name, mimeType, size, uri } = file;

  let fileToUpload = {
    name: name,
    size: size,
    uri: uri,
    type: mimeType,
  };

  return fileToUpload;
};